import type {FormControl} from '../forms/form-control';

interface TouchedActionParams {
    formControl: FormControl<unknown>;
    touchTriggerEvent?: string;
    touchedClass?: string;
    isDisabled?: boolean;
}

export function touched(node: HTMLElement, { formControl, touchTriggerEvent = 'blur', touchedClass = 'touched', isDisabled = false }: TouchedActionParams) {

    if (formControl.isTouched() && !node.classList.contains(touchedClass)) {
        node.classList.add(touchedClass);
    }

    const blurHandler = () => {
        if (isDisabled) {
            return;
        }

        if (!formControl.isTouched()) {
            formControl.setTouched();
            if (!node.classList.contains(touchedClass)) {
                node.classList.add(touchedClass);
            }
        }
    };

    node.addEventListener(touchTriggerEvent, blurHandler);
    return {
        destroy() {
            node.removeEventListener(touchTriggerEvent, blurHandler);
        }
    };
}